import { Theme } from '@mui/material';
import { ActivityMessage } from 'src/components/ActivityList/activity-list-item';
import { BoldText } from 'src/components/ActivityList/styled/bold-text';
import { formatToPhoneNumber } from 'src/components/FormattedPhoneInput/format-to-phone-number';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';

export const buildClientPhoneNumberMessage = (activity: ActivityFeed): ActivityMessage[] => {
  const actorName = activity.actor?.name?.trim() || '<Platform User>';
  const phoneNumberChange = activity.changes.find((c) => c.name === 'Phone Number');
  if (!phoneNumberChange) {
    return [];
  }

  switch (activity.activityType) {
    case 'create': {
      if (!phoneNumberChange.value) {
        return [];
      }
      const phoneNumber = formatToPhoneNumber(phoneNumberChange.value);
      return [
        {
          id: activity.id,
          icon: 'mobile_check',
          color: (theme: Theme) => theme.palette.custom.OV.sys.primary,
          message: `${actorName} added phone number: ${phoneNumber}`,
          timestamp: activity.timestamp,
        },
      ];
    }
    case 'update': {
      return activity.changes
        .filter(({ value, previousValue }) => value !== previousValue)
        .map((activityChange) => {
          const { name } = activityChange;
          if (!!activityChange.value && !!activityChange.previousValue) {
            const value = formatToPhoneNumber(activityChange.value);
            const previousValue = formatToPhoneNumber(activityChange.previousValue);
            return {
              id: `${activity.id}-${name}`,
              icon: 'edit_attributes',
              color: (theme: Theme) => theme.palette.custom.OV.sys.tertiary,
              message: (
                <>
                  {actorName} changed the <BoldText>{name}</BoldText> from{' '}
                  <BoldText>&quot;{previousValue}&quot;</BoldText> to{' '}
                  <BoldText>&quot;{value}&quot;</BoldText>
                </>
              ),
              timestamp: activity.timestamp,
            };
          } else if (!!activityChange.value && !activityChange.previousValue) {
            const value = formatToPhoneNumber(activityChange.value);
            return {
              id: `${activity.id}-${name}`,
              icon: 'edit_attributes',
              color: (theme: Theme) => theme.palette.custom.OV.sys.tertiary,
              message: (
                <>
                  {actorName} added the {name} <BoldText>&quot;{value}&quot;</BoldText>
                </>
              ),
              timestamp: activity.timestamp,
            };
          }
          return null;
        })
        .filter((value) => !!value);
    }
    case 'delete': {
      if (!phoneNumberChange.previousValue) {
        return [];
      }
      const phoneNumber = formatToPhoneNumber(phoneNumberChange.previousValue);
      return [
        {
          id: activity.id,
          icon: 'mobile_cancel',
          color: (theme: Theme) => theme.palette.custom.OV.sys.error,
          message: `${actorName} deleted phone number ${phoneNumber}`,
          timestamp: activity.timestamp,
        },
      ];
    }
    default:
      return [];
  }
};
